<template>
  <footer :class="['footer',  _isMobile()?'mobile':'']">
      <div v-html="tenantInfo && tenantInfo.footer" style="text-align:left"></div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: "Footer",
  mixins: [mixinDevice],
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = this.$store.getters.tenantInfo
  },
};
</script>
<style lang="less" scoped>
.mobile{
  padding-left:25px;
  padding-right:25px;
  min-height: 120px!important;
}
footer {
  // background: #2B8AB9 url(../assets/footerbg.png) no-repeat;
  // border-top: 1px solid #8d8d8d;
  color: #666;
  width: 100%;
  min-height: 250px;
  bottom:0;
  margin-top: 15px;
  padding-top: 40px;
  padding-bottom: 15px;
  text-align: center;
}
.logo{
  max-width:80%
}
</style>